<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    <path d="M21,0H6A3,3,0,0,0,3,3V7.5a1,1,0,0,0,1,1H4a1,1,0,0,0,1-1V7.25A.25.25,0,0,1,5.25,7h16.5a.25.25,0,0,1,.25.25V12a1,1,0,0,1-.535.885.939.939,0,0,0-.465.842h0a1,1,0,0,0,1.451.9A3,3,0,0,0,24,12V3A3,3,0,0,0,21,0ZM5.25,4A.25.25,0,0,1,5,3.75V3A1,1,0,0,1,6,2H21a1,1,0,0,1,1,1v.75a.25.25,0,0,1-.25.25Z"/><path d="M17,10H2a2,2,0,0,0-2,2V22a2,2,0,0,0,2,2H17a2,2,0,0,0,2-2V12A2,2,0,0,0,17,10ZM6,15.5a.5.5,0,0,1-.5.5h-2a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5ZM14.5,21a1.992,1.992,0,0,1-1.333-.51.251.251,0,0,0-.334,0,2,2,0,1,1,0-2.98.251.251,0,0,0,.334,0A2,2,0,1,1,14.5,21Z"/>
  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'credit-card',
    },
    name: {
      type: String,
      required: false,
      default: 'CreditCard',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>